import React, {Component} from 'react';
import moment from 'moment';
import {isEmpty} from 'lodash';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Card, Header, Form, Button, Progress} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {dateFormatShortMonth} from '../../../common/constants/datesFormat';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import {calcDays} from '../utils';
import Loader from '../../../common/components/loader';
import FormClientWaitHappy from '../common/FormClient';
import FormVehicleWaitHappy from '../common/FormVehicle';
import FormDealereWaitHappy from '../common/FormDealer';
import BudgetText from '../common/BudgetText';
import './styles.scss';

const Divisor = ({text}) => {
  return (
    <p style={{'textAlign': 'left'}} className='warranty-divisor'> {text}</p>
  );
};

class DealerWaitHappy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'deliveryDateReal': null,
      'deliveryDateEstimate': null,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.DealerWaitHappy, scopes.See)) {
      this.props.push(paths.AccessDenied);
    }
    const {id} = this.props.params;
    this.props.getDetailWaitHappy(id);
  }

  componentDidUpdate(prevProps) {
    const {vehicleDetail} = this.props;
    const {deliveryDateReal, deliveryDateEstimate} = this.state;
    const {deliveryDateRealISO, deliveryDateEstimateISO} = vehicleDetail;

    if ((deliveryDateRealISO && !deliveryDateReal) ||
      (deliveryDateEstimateISO && !deliveryDateEstimate) ||
      (prevProps.vehicleDetail.deliveryDateRealISO !== deliveryDateRealISO)
    ) {
      this.setState({
        'deliveryDateReal': deliveryDateRealISO ?
          moment(deliveryDateRealISO) :
          null,
        'deliveryDateEstimate': deliveryDateEstimateISO ?
          moment(deliveryDateEstimateISO) :
          null,
      });
    }
  }

  componentWillUnmount() {
    this.setState({
      'deliveryDateReal': null,
      'deliveryDateEstimate': null,
    });
  }

  handleChange = (field, value) => {
    this.setState({
      [field]: value,
    });
  };

  handleSubmit = () => {
    const {vehicleDetail} = this.props;
    const {id} = vehicleDetail;
    const {'deliveryDateReal': real, 'deliveryDateEstimate': estimate} = this.state;
    const data = {
      id,
      'deliveryDateEstimate': estimate ? moment(estimate).format(dateFormatShortMonth) : '',
      'deliveryDateReal': real ? moment(real).format(dateFormatShortMonth) : '',
    };
    this.props.updateDealerWaitHappy(data);
    this.props.history.push(paths.ListVehiclesWaitHappy);
  };

  render() {
    const {deliveryDateReal, deliveryDateEstimate} = this.state;
    const {loading, vehicleDetail} = this.props;

    if (loading) {
      return <Loader/>;
    }

    if (isEmpty(vehicleDetail)) {
      return <div>
        <h3>No se encontro el vehículo</h3>
        <Link to={paths.ListVehiclesWaitHappy}>Regresar</Link>
      </div>;
    }

    const dealer = vehicleDetail.dealer;
    const agency = vehicleDetail.agency;
    const reserveDate = vehicleDetail.reserveDate;
    const reserveDateISO = vehicleDetail.reserveDateISO;
    const totalDays = calcDays(reserveDateISO, deliveryDateReal);
    const currentDays = calcDays(reserveDateISO, moment());
    

    return (
      <div>
        <Card raised fluid>
          <div className='container-vehicles-happy-wait pd'>
            <Header as='h3'>
              Espera feliz {dealer} {agency}{' '}
            </Header>
          </div>
        </Card>
        <Card raised fluid>
          <Form
            onSubmit={this.handleSubmit}
            className='pd container-form-happy-wait'
          >
            {totalDays && (
              <div>
                <div className='container-form-bar-happy-wait'>
                  <BudgetText
                    label='fecha inicio :'
                    text={reserveDate ? reserveDate : 'sin asignar'}
                  />
                  <BudgetText
                    label='fecha de llega :'
                    text={
                      deliveryDateReal ?
                        moment(deliveryDateReal).format('DD-MM-YYYY') :
                        'sin asignar'
                    }
                  />
                </div>
                <Progress
                  color='green'
                  progress='ratio'
                  value={currentDays}
                  total={totalDays}
                  label={`${currentDays} días de ${totalDays} días `}
                />
              </div>
            )}
            <Divisor text='Datos del cliente' />
            <FormClientWaitHappy detail={vehicleDetail} />
            <Divisor text='Datos del vehículo' />
            <FormVehicleWaitHappy
              detail={vehicleDetail}
            />
            <Divisor text='Datos de entrega' />
            <FormDealereWaitHappy
              detail={vehicleDetail}
              deliveryDateReal={deliveryDateReal}
              deliveryDateEstimate={deliveryDateEstimate}
              handleChange={this.handleChange}
            />
            <div className='mt mb container-button-happy-wait'>
              <Button color='green' type='submit'>
                Actualizar
              </Button>
            </div>
          </Form>
        </Card>
      </div>
    );
  }
}

const {
  withRouter,
  fetchAgenciesByDealer,
  getDetailWaitHappy,
  updateDealerWaitHappy,
} = Actions;

const mapStateToProps = (state, ownProps) => {
  return {
    'agencyCode': state.session.dealerAgency,
    'delaerList': state.dealer.agenciesList,
    'loadingDealderInfo': state.dealer.loading,
    'dealerId': state.session.dealerId,
    'permissions': state.session.permissions,
    'loading': state.waitHappyVehicleDetail.loading,
    'vehicleDetail': state.waitHappyVehicleDetail.data,
    'push': ownProps.history.push,
  };
};

export default withRouter(connect(mapStateToProps, {
  fetchAgenciesByDealer,
  getDetailWaitHappy,
  updateDealerWaitHappy,
})(DealerWaitHappy));
